import React from 'react';
import { useSelector } from 'react-redux';
import { SavedPaypalPaymentForm } from 'Forms/SavedPaypalForm/SavedPaypalForm';
import { getPaypalPaymentMethodId } from 'Utils/PaymentMethods';

export const PaypalPayment = ({ handleSavedPayment, submitButtonText, savedPaypalForm }) => {
  const paymentMethods = useSelector((s) => s.paymentMethods);
  const { paypalError } = useSelector((s) => s.checkout);
  return paymentMethods.hasPaypalPayment ? (
    <SavedPaypalPaymentForm
      ref={savedPaypalForm}
      paymentMethod={paymentMethods.paypalPayment}
      onFormSubmit={() => handleSavedPayment(getPaypalPaymentMethodId(paymentMethods.paypalPayment))}
      submitButtonText={submitButtonText}
    />
  ) : (
    <div className="paypalCaptureError">
      <div className="formSubmitError">{paypalError}</div>
    </div>
  );
};
